import axios from 'axios';
import Auth from '../services/auth';
import { API_ROOT } from './apiConfig';

export default class EomSystemDataAccess {

    getCodeList() {
        const auth = new Auth();

        return new Promise((resolve, reject) => {

            let reqBody = {
                account: "zuludatabase", command: "GetCodeMatrix"
            };

            axios.post(`${API_ROOT}/api/v1/qtype/Query`, reqBody,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${auth.getToken()}`
                    }
                }).then(function (response) {
                    sessionStorage.setItem('getCodeMatrix', JSON.stringify(response.data));
                    resolve(response.data);
                })
                .catch(error => {
                    console.log(error);
                });
        });
    }
}